import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import BootstrapTable from "src/components/BootstrapTable";
import DetailButton from "src/components/DetailButton";
import EditButton from "src/components/EditButton";
import Title from "src/components/Title";
import TableFormatter from "src/utils/tableFormatter";

const TaggroupsOverviewSite = () => {
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <Row>
        <Col>
          <Title>Taggruppen-Übersicht</Title>
        </Col>
      </Row>

      <Row className="add-margin">
        <Col className="text-end">
          <Button variant="default" onClick={() => navigate(`/taggroup/add`)}>
            Neue Taggruppe
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <BootstrapTable
            url="/api/backend/taggroups"
            sort="name"
            order="asc"
            showSearch
            showClear
            showRefresh
            pageSize={25}
            pageSizes={[25, 50, 100, 250]}
            columns={[
              {
                field: "name",
                name: "Name",
                sortable: true,
              },
              {
                field: "gui_order",
                name: "GUI-Reihenfolge",
                sortable: true,
              },
              {
                field: "is_visible_for_view",
                name: "Sichtbar für User",
                sortable: true,
                formatter: TableFormatter.formatBoolean,
              },
              {
                field: "is_visible_for_filtering",
                name: "Filterbar",
                sortable: true,
                formatter: TableFormatter.formatBoolean,
              },
              {
                field: "is_visible_for_edit",
                name: "Sichtbar bei Erfassung",
                sortable: true,
                formatter: TableFormatter.formatBoolean,
              },
              {
                field: "is_multiple_on_enter",
                name: "Mulit-Auswahl",
                sortable: true,
                formatter: TableFormatter.formatBoolean,
              },
              {
                field: "id",
                textAlign: "right",
                width: 80,
                formatter: (value) => {
                  return (
                    <React.Fragment>
                      <DetailButton url={`/taggroup/${value}`} />{" "}
                      <EditButton url={`/taggroup/edit/${value}`} />
                    </React.Fragment>
                  );
                },
              },
            ]}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default TaggroupsOverviewSite;
